import * as React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import toast from 'cogo-toast';
import dayjs from 'dayjs';
import {
  Page,
  Grid,
  Card,
  Button,
  Icon,
  Header,
  Text,
  Dropdown,
} from 'tabler-react';
import copy from 'copy-to-clipboard';
import ShareModal from './ShareModal';
import TrialCards from './TrialCards';
import VasCards from './VasCards';

import Request from '../../shared/request';
import Modal from '../../components/Modal';
import PageComponent from '../PageComponent';
import store from '../../shared/store';
import cardEmpty from '../../assets/card_empty.png';
import './home.scss';
import i18n from '../../shared/i18n';

const CARDS = {
  PROMOCODE: {
    name: '优惠券',
    tip: '查看使用规则',
    rules: ['可以在购买时使用抵扣金额', '请注意过期时间'],
  },
  PROMO: {
    name: '邀请卡',
    tip: '朋友激活，双方获得时长',
    rules: ['VIP不可使用', '每人只能使用一张', '每激活一张将获得同等时长'],
  },
  SALE: {
    name: '充值卡',
    tip: '查看使用规则',
    rules: ['任何人都可以使用', '请在过期前使用掉'],
  },
};

const ConfirmEmail = props => {
  if (store.user.needBindEmail) {
    return (
      <Grid.Row>
        <Grid.Col sm={12}>
          <div className="malus-tip email-confirm-tip">
            <span>{i18n.t('dash-tip-bindemail')}</span>
            <Link to="/dashboard/bind-email">
              <Button color="danger" size="sm">
              {i18n.t('dash-tip-bindemailbtn')}
              </Button>
            </Link>
          </div>
        </Grid.Col>
      </Grid.Row>
    );
  }
  if (store.user.needSetPassword) {
    return (
      <Grid.Row>
        <Grid.Col sm={12}>
          <div className="malus-tip email-confirm-tip">
            <span>{i18n.t('dash-tip-setpassword')}</span>
            <Link to="/dashboard/set-password">
              <Button color="danger" size="sm">
              {i18n.t('dash-tip-setpasswordbtn')}
              </Button>
            </Link>
          </div>
        </Grid.Col>
      </Grid.Row>
    );
  }
  if (props.status === 'UNCONFIRM') {
    return (
      <Grid.Row>
        <Grid.Col sm={12}>
          <div className="malus-tip email-confirm-tip">
            <span>{i18n.t('dash-tip-confirmemail')}</span>
            <Link to="/dashboard/email">
              <Button color="danger" size="sm">
              {i18n.t('dash-tip-confirmemailbtn')}
              </Button>
            </Link>
          </div>
        </Grid.Col>
      </Grid.Row>
    );
  }
  return <></>;
};

class Home extends PageComponent {
  state = {
    notifications: [],
    cards: null,
    referStats: null,
    referLink: null,
    shareText: null,
    isOpen: false,
    affId: null,
    affiliate: {},
    total: 0,
  };

  constructor(props) {
    super(props);
    if (store.user && store.user.affId) {
      this.state.affid = store.user.affId;
    }
  }

  showModal = () => {
    const shareModal = (
      <ShareModal
        referLink={this.state.referLink}
        shareText={this.state.shareText}
        referStats={this.state.referStats}
      />
    );
    Modal(shareModal, { title: i18n.t('dash-aff-title') });
  };

  componentWillMount() {
    if (window.location.href.includes('referral')) {
      this.setState({ showReferral: true });
    }
  }

  async componentDidMount() {
    try {
      const objectSearch = new URLSearchParams(window.location.search);
      const message = objectSearch.get('message');
      if (message) {
        toast.info(message);
      }
    } catch (err) {
      // noop
    }
    await store.dispatch({ type: 'updateUser' });
    const { showReferral } = this.state;

    const cards = await Request.call('getCards');
    const overview = await Request.call('getCreditOverview');
    this.setState({
      cards,
      affiliate: overview.affiliate,
      total: overview.total,
    });
    // const pointsStatus = await Request.call('getPointsStatus');
    // this.setState({ pointsStatus });
    const res = await Request.call('getReferStats');
    if (res) {
      const referLink = `https://getmalus.com/invite?affid=${overview.affiliate.affid
        }`;
      this.setState({
        referStats: res.data,
        referLink,
        shareText: i18n.t('dash-aff-share1')
      });

      if (showReferral) {
        this.showModal();
      }
    }
  }

  showTrialCards = () => {
    const trialCards = (
      <TrialCards
        referLink={this.state.referLink}
        shareText={[
          this.state.shareText,
          `。登录后即可兑换，还有${this.getTrialCards().length}张体验卡：\n`,
          this.getTrialCards()
            .map(card => card.code)
            .join('\n'),
        ].join('')}
      />
    );
    Modal(trialCards, {
      title: '可用体验卡（好友激活多少返多少）',
    });
  };

  trialDesc = () => {
    if (store.user.trialPlanId === 'TURBO') {
      return `${i18n.t('dash-user-game')} ${dayjs(store.user.trialExpiredAt).format(
        'YYYY.MM.DD',
      )}`;
    }
    return `${i18n.t('dash-user-game')} ${dayjs(store.user.trialExpiredAt).format('YYYY.MM.DD')}`;
  };

  copyUID = () => {
    copy(store.user.uid);
    toast.info(i18n.t('dash-tip-copyok'));
  };

  render() {
    if (
      window.location.pathname.split('/').pop() === 'referral' &&
      !this.state.isOpen
    ) {
      return <Redirect to="/dashboard" />;
    }

    return (
      <Page.Content>
        <ConfirmEmail status={store.user.status} />

        <Grid.Row cards>
          <Grid.Col xl={4} lg={6} md={12} sm={12} xs={12}>
            <Card className="stats-card">
              <div className="stats-icon">
                <Icon name="user" />
              </div>
              <div className="stats-detail">
                <span>{i18n.t('dash-user-type')}</span>
                <div className="stats-member">
                  <Header.H6>{store.user.userDesc}</Header.H6>
                  <Header.H6>
                    {store.user.planExpiredAt > 0
                      ? dayjs(store.user.planExpiredAt).format('YYYY.MM.DD')
                      : ''}
                  </Header.H6>
                </div>
                {store.user.isTrial ? (
                  <div className="malus-invite-tips game-trial">
                    {/* <Icon name="zap" /> */}
                    <span>{this.trialDesc()}</span>
                  </div>
                ) : (
                  ''
                )}
                <div className="malus-invite-tips" onClick={this.copyUID}>
                  ID{store.user.uid}
                </div>
              </div>
              <a
                href="/buy?utm_source=dashboard&utm_medium=status"
                target="noopener noreferrer">
                <Button pill color="primary" size="sm">
                  {store.user.userType !== 'FREE' ? i18n.t('dash-user-renew') : i18n.t('dash-user-upgrade')}
                </Button>
              </a>
            </Card>
          </Grid.Col>
          <Grid.Col xl={4} lg={6} md={12} sm={12} xs={12}>
            <Card className="stats-card">
              <div className="stats-icon stats-icon-user">
                <Icon name="user-plus" />
              </div>
              <div className="stats-detail">
                <span>{i18n.t('dash-aff-invitecount')}</span>
                <div className="stats-member">
                  <Header.H2>
                    {this.state.affiliate ? this.state.affiliate.count : 0}
                  </Header.H2>
                  <Header.H6 />
                </div>
              </div>

              <div className="malus-invite-tips">
                {i18n.t('dash-aff-invitetip')}
              </div>
            </Card>
          </Grid.Col>
          <Grid.Col xl={4} lg={12} md={12} sm={12} xs={12}>
            <Card className="stats-card">
              <div className="stats-icon stats-icon-time">
                <Icon name="credit-card" />
              </div>
              <div className="stats-detail">
                <span>{i18n.t('dash-card-title')}</span>
                <div className="stats-member">
                  {/* <Header.H2>
                    {this.state.pointsStatus
                      ? this.state.pointsStatus.total
                      : '-'}
                  </Header.H2> */}
                  <Header.H2>{this.getTrialCards().length}</Header.H2>
                </div>
              </div>
              <Button
                pill
                outline
                color="orange"
                size="sm"
                onClick={this.showTrialCards}>
                {i18n.t('dash-aff-invitebtn')}
              </Button>
              <div className="malus-invite-tips">{i18n.t('dash-aff-invitetip')}</div>
            </Card>
          </Grid.Col>
        </Grid.Row>

        <Grid.Row cards>
          <Grid.Col xl={4} lg={6} md={12} sm={12} xs={12}>
            <Card className="vip-center">
              <Card.Header>
                <Card.Title>{i18n.t('dash-user-benifits')}</Card.Title>
              </Card.Header>
              <Card.Body className="vas-body">
                <VasCards {...this.props} />
              </Card.Body>
            </Card>
          </Grid.Col>

          <Grid.Col xl={4} lg={6} md={12} sm={12} xs={12}>
            <Card className="share-center">
              <Card.Header>
                <Card.Title>{i18n.t('dash-aff-title')}</Card.Title>
                {this.getInviteButton()}
              </Card.Header>
              <Card.Body>
                <ShareModal
                  referLink={this.state.referLink}
                  shareText={i18n.t('dash-aff-share1')}
                  referStats={this.state.referStats}
                />
                {/* <ShareModal /> */}
              </Card.Body>
            </Card>
          </Grid.Col>

          <Grid.Col xl={4} lg={6} md={12} sm={12} xs={12}>
            <Card className="act-center">
              <Card.Header>
                <Card.Title>{i18n.t('dash-card-title')}</Card.Title>
              </Card.Header>
              <Card.Body>{this.getCards()}</Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>
      </Page.Content>
    );
  }

  getCards() {
    const { cards: realCards } = this.state;
    const cards = realCards ? [...realCards] : [];
    if (store.user.isEdu) {
      cards.push({
        id: null,
        code: 'EDUCATION',
        type: 'PROMOCODE',
        days: 0,
        promoCode: { off: '30' },
        expiredAt: 0,
      });
    }
    if (store.user.buyTag) {
      cards.push({
        id: null,
        code: store.user.buyTag,
        type: 'PROMOCODE',
        days: 0,
        promoCode: { off: '20' },
        expiredAt: store.user.planExpiredAt,
      });
    }

    if (!cards) {
      return (
        <Grid.Row>
          <Grid.Col>
            <Card>
              <Card.Body>
                <Text align="center">Loading...</Text>
              </Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>
      );
    }

    if (!cards.length) {
      return (
        <Grid.Row>
          <Grid.Col>
            <Card>
              <Card.Body>
                <div className="card-empty">
                  <img src={cardEmpty} alt="empty-icon" />
                  <Text align="center">{i18n.t('dash-card-empty')}</Text>
                </div>
              </Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>
      );
    }

    return cards.map(card => {
      switch (card.type) {
        case 'SALE':
        case 'PROMO':
          if (card.code.startsWith('TNEW')) {
            return (
              <Card.Body
                className={`ac-card ac-card-${card.type.toLowerCase()}`}>
                <div className="ac-card-left ac-card-left-promo">
                  <div className="top">
                    <h3>{(card.promo || card.sale).days}</h3>
                    <small>天</small>
                  </div>
                  <span className="card-type">{CARDS[card.type].name}</span>
                </div>
                <div className="ac-card-right">
                  <div className="top">
                    <span className="card-code" id={`card_${card.code}`}>
                      {card.code}
                      <CopyToClipboard
                        text={card.code}
                        onCopy={() => toast.success(i18n.t('dash-tip-copyok'))}>
                        <Button icon="clipboard" size="sm" />
                      </CopyToClipboard>
                    </span>
                  </div>
                  <div className="bottom">
                    <span>
                      {dayjs(card.expiredAt).format('YYYY-MM-DD')} 到期
                    </span>
                    <Button
                      color="orange"
                      size="sm"
                      onClick={() => window.open(`/active?code=${card.code}`)}>
                      {i18n.t('dash-card-use')}
                    </Button>
                  </div>
                </div>
              </Card.Body>
            );
          }
          return (
            <Card.Body className={`ac-card ac-card-${card.type.toLowerCase()}`}>
              <div className="ac-card-left ac-card-left-promo">
                <div className="top">
                  <h3>{(card.promo || card.sale).days}</h3>
                  <small>天</small>
                </div>
                <span className="card-type">{CARDS[card.type].name}</span>
              </div>
              <div className="ac-card-right">
                <div className="top">
                  <span className="card-code" id={`card_${card.code}`}>
                    {card.code}
                    <CopyToClipboard
                      text={card.code}
                      onCopy={() => toast.success(i18n.t('dash-tip-copyok'))}>
                      <Button icon="clipboard" size="sm" />
                    </CopyToClipboard>
                  </span>
                </div>
                <div className="bottom">
                  <span>
                    {card.expiredAt
                      ? `${dayjs(card.expiredAt).format('YYYY-MM-DD')} 到期`
                      : '永久有效'}
                  </span>
                  {card.type === 'PROMO' ? (
                    <Button
                      color="orange"
                      size="sm"
                      onClick={this.showTrialCards}>
                      {i18n.t('dash-card-share')}
                    </Button>
                  ) : (
                    <Button
                      color="orange"
                      size="sm"
                      onClick={() => window.open(`/active?code=${card.code}`)}>
                      {i18n.t('dash-card-use')}
                    </Button>
                  )}
                </div>
                <div className="card-info">
                  <Dropdown
                    triggerContent={CARDS[card.type].tip}
                    arrow
                    itemsObject={CARDS[card.type].rules.map(value => ({
                      value,
                    }))}
                  />
                  <Icon name="chevron-right" />
                </div>
              </div>
            </Card.Body>
          );
        case 'PROMOCODE':
          return (
            <Card.Body className="ac-card">
              <div className="ac-card-left">
                <div className="top">
                  <h3>{card.promoCode.off}%</h3>
                  <small>折扣</small>
                </div>
                <span className="card-type">{CARDS[card.type].name}</span>
              </div>
              <div className="ac-card-right">
                <div className="top">
                  <span className="card-code">
                    {card.code}
                    <CopyToClipboard
                      text={card.code}
                      onCopy={() => toast.success(i18n.t('dash-tip-copyok'))}>
                      <Button icon="clipboard" size="sm" />
                    </CopyToClipboard>
                  </span>
                </div>
                <div className="bottom">
                  <span>
                    {card.expiredAt
                      ? `${dayjs(card.expiredAt).format('YYYY-MM-DD')} 到期`
                      : '永久有效'}
                  </span>
                  <Button
                    RootComponent="a"
                    href={`/buy?code=${card.code
                      }&utm_source=dashboard&utm_medium=card`}
                    color="success"
                    size="sm"
                    target="noopener noreferrer">
                    立即使用
                  </Button>
                </div>
                <div className="card-info">
                  <Dropdown
                    triggerContent={CARDS[card.type].tip}
                    arrow
                    itemsObject={CARDS[card.type].rules.map(value => ({
                      value,
                    }))}
                  />
                  <Icon name="chevron-right" />
                </div>
              </div>
            </Card.Body>
          );
        default:
          return null;
      }
    });
  }

  getInviteButton() {
    const { user } = store;
    return user.status === 'UNCONFIRM' ? (
      <div className="refer-days disabled">
        <i className="ri-information-line" />
        {i18n.t('dash-aff-confirmemail')}
      </div>
    ) : (
      <div className="refer-days">
        {i18n.t('dash-aff-total')}
        <strong>{this.state.total}</strong>
      </div>
    );
  }

  getTrialCards() {
    const { cards } = this.state;
    if (!cards) return [];
    return cards.filter(card => card.type === 'PROMO');
  }
}

export default Home;
